function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from '../../shared/components/spzaComponent';
import { postMessageToHost, getProductByUrlKey } from '../../shared/utils/appUtils';
import { constants } from '../constants';
import { Constants } from '../../shared/utils/constants';
import * as embedHostUtils from '../embedHostUtils';
import { ExternalLink } from '@shared/components/externalLink';
import { logger } from '@src/logger';
import { getWindow } from '@shared/services/window';
class Header extends SpzaComponent {
    componentDidMount() {
        var _getWindow;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        var _getWindow;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener('keydown', this.handleKeyDown);
    }
    closeHandler() {
        const payload = {
            page: 'In App Gallery',
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.Info,
            details: 'Clicked on exit. Closing In App gallery experience'
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page
        });
        postMessageToHost({
            msgType: constants.actionTypes.closeSaasMarketplace
        });
    }
    logNoContentTelemetry(link, linkType) {
        var _getProductByUrlKey;
        const details = {
            linkType,
            link,
            tab: 'Default'
        };
        const payload = {
            page: 'In App Gallery(' + ((_getProductByUrlKey = getProductByUrlKey({
                urlKey: this.props.embedHost
            })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey) + ')',
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.Link,
            details: JSON.stringify(details)
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page
        });
    }
    shouldShowCloseButtonForParams(query) {
        if (!!query && embedHostUtils.isFullScreenMode(query)) {
            return false;
        }
        return true;
    }
    renderImpl() {
        var _getProductByUrlKey;
        let product = (_getProductByUrlKey = getProductByUrlKey({
            urlKey: this.props.embedHost
        })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey;
        let embedHostName = '';
        // HACK: for old Dynamics 365 the embedHost is set to dynamics-365-for-sales
        // but we want to show 'Dynamics 365' in the Embed Header component
        if (product === Constants.dynamics365.salesED) {
            product = 'dynamics-365';
        }
        const productInfo = getProductByUrlKey({
            urlKey: product
        });
        if (product && productInfo) {
            embedHostName = productInfo.EmbedContainerTitle || productInfo.Title || '';
        }
        let headerText = this.context.locParams('AppsFor_Title', [
            embedHostName
        ]);
        if (product === Constants.adminPortal) {
            headerText = embedHostName;
        }
        const headerClass = 'embedHeader' + (embedHostUtils.shouldShowLegacyStyle(this.props.embedHost) ? ' legacyStyle' : '');
        return /*#__PURE__*/ _jsx("div", {
            className: headerClass,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "headerBarEmbedded",
                children: [
                    /*#__PURE__*/ _jsx(ExternalLink, {
                        href: "https://appsource.microsoft.com/",
                        target: "_blank",
                        className: "c-heading-4 headerText",
                        tabIndex: 0,
                        onClickHandle: ()=>{
                            this.logNoContentTelemetry('https://appsource.microsoft.com/', 'Embed_Header');
                        },
                        accessibilityEnabled: true,
                        children: "AppSource"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "separator"
                    }),
                    /*#__PURE__*/ _jsx("h4", {
                        className: "c-heading-4 headerText",
                        children: headerText
                    }),
                    embedHostUtils.shouldShowCloseButton(this.props.embedHost) && this.shouldShowCloseButtonForParams(this.props.query) ? /*#__PURE__*/ _jsx("button", {
                        className: "headerCloseBtn",
                        onClick: this.closeHandler,
                        "aria-label": "close",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "c-glyph"
                        })
                    }) : null
                ]
            })
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0), _define_property(this, "handleKeyDown", (event)=>{
            if (event.key === 'Escape') {
                this.closeHandler();
            }
        });
    }
}
export { Header as default };
Header.contextTypes = {
    locParams: PropTypes.func,
    renderErrorModal: PropTypes.func
};
